"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Info = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Info = function (props) { return (react_1.default.createElement("svg", tslib_1.__assign({ width: "31", height: "31", viewBox: "0 0 31 31", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    react_1.default.createElement("g", { opacity: "0.9" },
        react_1.default.createElement("circle", { cx: "15.5003", cy: "15.4998", r: "13.5833", stroke: "#353F49", strokeWidth: "2" }),
        react_1.default.createElement("ellipse", { cx: "15.5003", cy: "9.66683", rx: "1.45833", ry: "1.45833", fill: "#353F49" }),
        react_1.default.createElement("rect", { x: "14.042", y: "14.0415", width: "2.91667", height: "10.2083", rx: "1", fill: "#353F49" })))); };
exports.Info = Info;
//# sourceMappingURL=Info.js.map